import { render, staticRenderFns } from "./platformTaskEdit.vue?vue&type=template&id=e38b87cc&scoped=true"
import script from "./platformTaskEdit.vue?vue&type=script&lang=js"
export * from "./platformTaskEdit.vue?vue&type=script&lang=js"
import style0 from "./platformTaskEdit.vue?vue&type=style&index=0&id=e38b87cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38b87cc",
  null
  
)

export default component.exports